import Select from 'react-select';
import { IOpcao } from '@/shared/types/selectOption';
import { useDataTableStateStates } from '@/shared/components/tables/useDataTableState';

interface PendenciasFiltersProps {
  filtrosStatus: IOpcao[];
  statusBusca: number;
  setStatusBusca: (v: number) => void;
  filtroResponsavel?: string;
  setFiltroResponsavel: (v?: string) => void;
  filtroEstagiario?: number;
  setFiltroEstagiario: (v?: number) => void;
  responsaveis: IOpcao[];
  estagiarios: IOpcao[];
  tableState: useDataTableStateStates;
  exibirFiltroResponsavel: boolean;
}

export function PendenciasFilters({
  filtrosStatus,
  statusBusca,
  setStatusBusca,
  filtroResponsavel,
  setFiltroResponsavel,
  filtroEstagiario,
  setFiltroEstagiario,
  responsaveis,
  estagiarios,
  tableState,
  exibirFiltroResponsavel,
}: PendenciasFiltersProps) {
  return (
    <div className="row mb-3">
      <div className="col-md-3">
        <label htmlFor="statusfolha_pendencias" className="col-form-label">
          Status da Folha:
        </label>
        <select
          className="form-select"
          id="statusfolha_pendencias"
          onChange={(e) => {
            tableState.setCurrentPage(1);
            setStatusBusca(Number(e.target.value));
          }}
          value={statusBusca}
        >
          <option value={0}></option>
          {filtrosStatus.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>

      {exibirFiltroResponsavel &&
        responsaveis.filter((item) => Number(item.value) !== 0).length > 0 && (
          <div className="col-md-3">
            <label htmlFor="filtroresponsavel_pendencias" className="col-form-label">
              Responsável:
            </label>
            <Select
              id="filtroresponsavel_pendencias"
              options={responsaveis}
              value={
                filtroResponsavel
                  ? responsaveis.find((a) => String(a.value) === filtroResponsavel)
                  : null
              }
              onChange={(option) => {
                tableState.setCurrentPage(1);
                const value = option ? String(option.value) : undefined;
                setFiltroResponsavel(value && value !== '0' ? value : undefined);
              }}
            />
          </div>
        )}

      {estagiarios.length > 2 && (
        <div className="col-md-3">
          <label htmlFor="filtroestagiario_pendencias" className="col-form-label">
            Estagiário:
          </label>
          <Select
            id="filtroestagiario_pendencias"
            options={estagiarios}
            value={
              filtroEstagiario
                ? estagiarios.find((a) => a.value === filtroEstagiario)
                : null
            }
            onChange={(option) => {
              tableState.setCurrentPage(1);
              const value = option ? Number(option.value) : undefined;
              setFiltroEstagiario(value && value > 0 ? value : undefined);
            }}
          />
        </div>
      )}
    </div>
  );
}
